class Emolumento {
  constructor() {
    
  }
}

export default Emolumento
